import Image from '@components/Image'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Team = (props: RealEstateDataPageComponentData) => {
  const { title, subtitle, paragraph, team } = props
  return (
    <section className="team-section a">
      <Container className="container-fluid text-center">
        <h2 className="mb-lg-5 mb-3">{title}</h2>
        <h4>{subtitle}</h4>
        <p className="text-justify mx-auto"> {paragraph}</p>
        <Row className="justify-content-center">
          <Col
            xs={12}
            className="d-lg-flex justify-content-center"
          >
            {team?.map(({ id, name, position, image_gatsby }) => (
              <div
                className="member"
                key={id}
              >
                <Image
                  image={image_gatsby!}
                  objectFit="cover"
                  alt={name!}
                  className=""
                />
                <h5>{name}</h5>
                <small className="bold">{position}</small>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Team
